/* eslint-disable camelcase */
/* eslint-disable no-useless-escape */
import * as Yup from 'yup';

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const whitespacesReg = /^\s*\S.*$/;
const specialCharReg = /^[^<>'\"/;`%]*$/;

export const getValidationSchema = () =>
  Yup.object().shape(
    {
      firstName: Yup.string()
        .required('Please fill out the rest fields. This is mandatory.')
        .max(35, 'Too many characters.')
        .matches(whitespacesReg, 'The field cannot contain only spaces.')
        .matches(specialCharReg, 'Special characters are prohibited.'),
      lastName: Yup.string()
        .required('Please fill out the rest fields. This is mandatory.')
        .max(35, 'Too many characters.')
        .matches(whitespacesReg, 'The field cannot contain only spaces.')
        .matches(specialCharReg, 'Special characters are prohibited.'),
      tel: Yup.string()
        .when('tel', (val) => {
          if (val && val.length > 0) {
            return Yup.string().matches(phoneRegExp, 'Phone number is not valid');
          }
          return Yup.string().notRequired();
        })
        .nullable(),
      reserveEmail: Yup.string()
        .nullable(true)
        .when('reserveEmail', (val) => {
          if (val && val.length > 0) {
            return Yup.string().email('Email is invalid');
          }
          return Yup.string().notRequired();
        }),
    },
    [
      ['tel', 'tel'],
      ['reserveEmail', 'reserveEmail'],
    ]
  );
